import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const InputBindings = () => {
    const { t } = useTranslation();

    const { isInputBindingPanelOpen, setIsInputBindingPanelOpen } = usePlacementStore(
        useShallow((state) => ({
            isInputBindingPanelOpen: state.isInputBindingPanelOpen,
            setIsInputBindingPanelOpen: state.setIsInputBindingPanelOpen
        }))
    );

    return (
        <Menu.Item
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="keyboard" />
            }
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralOpenKeyBindingPanel} className="min-w-24" />}
            onClick={() => setIsInputBindingPanelOpen(!isInputBindingPanelOpen)}
        >
            {t('labelInputBindings')}
        </Menu.Item>
    );
};
